import axios from "../../privateApi";

export const markSbcSetSolved = (setId: number, didComplete: boolean) =>
  axios.post("/mark-sbc-set-solved", { setId, solved: didComplete });
